import { Link } from "react-router-dom";
import { CalendarClock, ClipboardCheck, PackagePlus, Bike, PlaySquare, LockKeyhole } from "lucide-react";
import { getProfile } from "./api";
import { Shell, Panel } from "./ui";

export default function Home() {
  const profile = getProfile();
  const isTrainer = profile?.kind === "trainer" || profile?.role === "trainer";
  const initials = (profile?.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  if (isTrainer) {
    return (
      <Shell title="Venue Operations">
        <div className="flex items-center gap-3 mb-6" data-testid="trainer-home-greeting">
          <span className="h-12 w-12 rounded-full bg-[#ff2e4d]/20 text-[#ff2e4d] flex items-center justify-center font-bold">{initials}</span>
          <div>
            <p className="text-xl uppercase italic leading-tight" style={{ fontFamily: "Anton, sans-serif" }}>Hi, {profile?.name?.split(" ")[0]}</p>
            <p className="text-xs text-white/45">Trainer</p>
          </div>
        </div>
        <div className="space-y-4">
          <Link to="/staff/sundries" data-testid="home-sundries" className="block">
            <Panel className="p-5 flex items-center gap-5 active:scale-[0.99] transition">
              <PackagePlus size={28} className="text-white/70" />
              <span>
                <span className="block text-xl uppercase" style={{ fontFamily: "Anton, sans-serif" }}>Sundries request</span>
                <span className="block text-sm text-white/50">Report supplies that need restocking.</span>
              </span>
            </Panel>
          </Link>
          <Link to="/staff/bikes" data-testid="home-bikes" className="block">
            <Panel className="p-5 flex items-center gap-5 active:scale-[0.99] transition">
              <Bike size={28} className="text-white/70" />
              <span>
                <span className="block text-xl uppercase" style={{ fontFamily: "Anton, sans-serif" }}>Bike health log</span>
                <span className="block text-sm text-white/50">Report a fault or check a bike.</span>
              </span>
            </Panel>
          </Link>
          <Link to="/staff/scheduler" data-testid="home-scheduler" className="block">
            <Panel className="p-5 flex items-center gap-5 active:scale-[0.99] transition border-[#ff2e4d]/40">
              <CalendarClock size={28} className="text-[#ff2e4d]" />
              <span>
                <span className="block text-xl uppercase" style={{ fontFamily: "Anton, sans-serif" }}>Trainer scheduler system</span>
                <span className="block text-sm text-white/50">View your classes and arrange cover.</span>
              </span>
            </Panel>
          </Link>
        </div>
      </Shell>
    );
  }
  return (
    <Shell title="Venue Operations">
      <p className="text-white/55 text-sm mb-5" data-testid="staff-home-greeting">
        G'day {profile?.name?.split(" ")[0]} — {profile?.role}. What are you here to do?
      </p>
      <div className="space-y-4">
        {!isTrainer && (
          <Link to="/staff/checklist" data-testid="home-work-schedule" className="block">
            <Panel className="p-6 flex items-center gap-5 active:scale-[0.99] transition border-[#ff2e4d]/40">
              <ClipboardCheck size={34} className="text-[#ff2e4d]" />
              <span>
                <span className="block text-2xl uppercase italic" style={{ fontFamily: "Anton, sans-serif" }}>My work schedule</span>
                <span className="block text-sm text-white/50">Today's checklist, sign-off & shift report</span>
              </span>
            </Panel>
          </Link>
        )}
        <Link to="/staff/sundries" data-testid="home-sundries" className="block">
          <Panel className={`p-5 flex items-center gap-5 active:scale-[0.99] transition ${isTrainer ? "border-[#ff2e4d]/40" : ""}`}>
            <PackagePlus size={28} className={isTrainer ? "text-[#ff2e4d]" : "text-white/70"} />
            <span>
              <span className="block text-xl uppercase" style={{ fontFamily: "Anton, sans-serif" }}>Sundries request</span>
              <span className="block text-sm text-white/50">Running low? Ask for a restock</span>
            </span>
          </Panel>
        </Link>
        <Link to="/staff/bikes" data-testid="home-bikes" className="block">
          <Panel className={`p-5 flex items-center gap-5 active:scale-[0.99] transition ${isTrainer ? "border-[#ff2e4d]/40" : ""}`}>
            <Bike size={28} className={isTrainer ? "text-[#ff2e4d]" : "text-white/70"} />
            <span>
              <span className="block text-xl uppercase" style={{ fontFamily: "Anton, sans-serif" }}>Bike health log</span>
              <span className="block text-sm text-white/50">36 bikes · faults, repairs & history</span>
            </span>
          </Panel>
        </Link>
      </div>
      <div className="mt-8 flex items-center justify-between text-sm">
        <Link to="/staff/videos" data-testid="home-videos" className="inline-flex items-center gap-2 text-white/50 underline underline-offset-4 min-h-[44px]">
          <PlaySquare size={16} /> Training video library
        </Link>
        <Link to="/staff/manager" data-testid="home-manager" className="inline-flex items-center gap-2 text-white/35 min-h-[44px]">
          <LockKeyhole size={14} /> Manager
        </Link>
      </div>
    </Shell>
  );
}
